<template lang="pug">
modal.width-max(:title='$t("folders.managePermissionsModal.title")' @closeModal='closeModal')
  .list-wrapper
    .loader.row.middle(v-if='loading || foldersLoading')
      loader(size='inner')
    .users.kimple-scroll(v-else-if='userPermissions.length')
      .user.row.middle(v-for='user in users' :key='user.userId')
        img.avatar(:src='user.avatar || defaultProfileImage')
        .column.m-left-1
          .row.middle.ellipsis.username
            h2.text-normal.m-right-05 {{ user.fullName }}
            h2.text-normal.ellipsis(
              v-if='user.position.positionId || user.schoolName'
              :title='getPositionWithSchoolName(user.position, user.schoolName)'
            ) {{ getPositionWithSchoolName(user.position, user.schoolName) }}
          h4.text-small.dark-gray {{ user.email }}
        span.text-normal.gray.m-left-auto(v-if='user.permission === FOLDER_PERMISSIONS.owner') {{ $t('folders.managePermissionsModal.owner') }}
        .actions-container.row.middle.m-left-auto.m-right-05(v-else)
          k-select.permissions-select(
            :emptyOption='$t("folders.removeFolderAccess")'
            name='userPermission'
            :withBorder='false'
            small noSpacing transparent
            valueName='value'
            labelName='label'
            @selectOption='(name, value) => setPermission(user.user.userId, value)'
            :preselectedOption='user.permission'
            :options='permissionsOptions'
          )
    template(v-else)
      span.text-normal.dark-gray {{ $t('folders.managePermissionsModal.empty') }}
  .row.end.m4-top-7
    button.primary-button(type='button' @click='saveChanges') {{ $t('folders.managePermissionsModal.save') }}
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Modal from '../Modal'
import Loader from '@/components/Loader'
import KSelect from '@/components/KSelect'
import defaultProfileImage from '@/assets/empty_profile.svg'
import { updateUsersPermissions } from '../../services/FolderService'
import { FOLDER_PERMISSIONS } from '../../constants/folders'
import crossIcon from '../../assets/ic_cross.svg'
import { i18n } from '../../main'
import userPosition from '@/mixins/userPosition'

export default {
  mixins: [userPosition],
  components: { KSelect, Modal, Loader },
  data() {
    return {
      defaultProfileImage,
      crossIcon,
      loading: true,
      FOLDER_PERMISSIONS
    }
  },
  computed: {
    ...mapState({
      folderId: state => state.behavior.folderManagePermissionsModal.props.folderId,
      userPermissions: state => state.folders.userPermissions,
      foldersLoading: state => state.folders.foldersLoading
    }),
    users() {
      return this.userPermissions.map(user => ({ ...user, ...user.user }))
    },
    permissionsOptions() {
      return Object.keys(FOLDER_PERMISSIONS)
        .filter(key => key !== 'owner')
        .map(key => ({ label: i18n.t(`folders.${key}`), id: FOLDER_PERMISSIONS[key] }))
    }
  },
  async created() {
    await this.hydrateUserPermissions(this.folderId)
    this.loading = false
  },
  methods: {
    ...mapActions([
      'hydrateUserPermissions',
      'updatePermission',
      'deletePermission',
      'savePermissions',
      'cleanPermissions',
      'showElement',
      'hideElement'
    ]),
    closeModal() {
      this.hideElement({ element: 'folderManagePermissionsModal' })
      this.cleanPermissions()
    },
    setPermission(userId, permission) {
      this.updatePermission({ userId, permission })
    },
    async saveChanges() {
      this.showElement({ element: 'fullPageLoader' })
      const permissions = this.userPermissions.filter(userPerm => {
        return userPerm.permission && userPerm.permission !== FOLDER_PERMISSIONS.owner
      })
      await updateUsersPermissions(this.folderId, permissions)
      this.closeModal()
      this.hideElement({ element: 'fullPageLoader' })
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/variables/colors';

.list-wrapper {
  border-bottom: 1px solid $light-gray;
  border-top: 1px solid $light-gray;
  display: flex;
  flex-direction: column;
  height: 372px;
  justify-content: flex-start;
  margin: 20px 0 0;
  overflow-y: auto;
  padding: 20px 0;
  position: relative;
  .loader{
    height: 100%;
  }
}

.users{
  height: 100%;
  overflow-y: auto;
  &>:nth-child(even){
    background-color: $light-gray;
  }
}

.user{
  padding: 10px;
  height: 50px;
  .username{
    max-width: 410px;
  }
  .avatar{
    width: 30px;
    height: 30px;
    border-radius: 50%;
    object-fit: cover;
  }
}

::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-track {
  background: $white;
}

::-webkit-scrollbar-thumb {
  background: $gray;
  border-radius: 5px;
  height: 72px;
}

.width-max {
  --max-width: 720px;
}

.actions-container{
  width: 150px;
}
</style>
